import { apiConstants } from '../../apiConstant'
import {  serviceCall } from '../../serviceCall'



export const promocodeByIdApi = (data, callback, errorCallBack) => {
  return async (dispatch) => {
    serviceCall({
      url: apiConstants.PROMOCODE.PROMOCODE_BY_ID,
      method: 'get',
      data: data,
    })
      .then((response) => {
        callback && callback(response)
      })
      .catch((error) => {
        errorCallBack && errorCallBack(error.response)
      })
  }
}
